import { CatalogueType } from '@/config/types'
import { SiteName } from '@/scopes/common/domain/types'

type ImageType = 'sun_new' | 'winter' | 'eliza' | 'sun'

const seasons: Record<string, CatalogueType> = {
  SZ: 'summer',
  WG: 'winter',
  BZ: 'summer',
  BW: 'winter',
  FS: 'summer',
  FH: 'winter',
  FZ: 'summer',
  FW: 'winter',
  DW: 'winter',
  UW: 'winter',
  QZ: 'summer',
  QW: 'winter',
  KZ: 'summer',
  KW: 'winter',
  EZ: 'summer',
  BE: 'summer',
}

const summerImages: Record<SiteName, ImageType> = {
  sunwebnl: 'sun_new',
  sunwebdk: 'sun_new',
  sunwebde: 'sun_new',
  sunwebse: 'sun',
  sunwebfr: 'sun_new',
  sunwebuk: 'sun_new',
  sunwebbenl: 'sun_new',
  sunwebbefr: 'sun_new',
  gogonl: 'sun',
  elizanl: 'eliza',
  elizabe: 'eliza',
  elizauk: 'eliza',
}

const imagePositioning: Record<string, string> = {
  SZ: 'top center',
  WG: '50% 50%',
  KZ: 'top center',
  KW: '50% 50%',
  DW: '50% 50%',
  QZ: '50% 21%',
  QW: '50% 50%',
  FZ: 'top center',
  FW: '50% 50%',
  UW: '50% 50%',
  BZ: 'top center',
  BW: '50% 50%',
  FS: 'top center',
  FH: '50% 50%',
  EZ: '50% 56%',
  BE: '50% 56%',
}

function getSeason(publicationCode: string): CatalogueType {
  return seasons[publicationCode]
}

function getImageName(season: 'winter' | 'summer', site: SiteName) {
  return season === 'winter' ? 'winter' : summerImages[site]
}

function getImagePositioning(publicationCode: string): string {
  return imagePositioning[publicationCode]
}

export { getImageName, getImagePositioning, getSeason }
export type { ImageType }
